import React from 'react';
import { Card, Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

export default function IndividualPerformanceCard({ title, data, total }) {
  const header = ['Name', 'Revenue', 'Target', '%'];
  const row = ['name', 'revenue', 'target', 'percentage'];

  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
        border: '1px solid #E2E8F0',
        overflow: 'hidden',
        width: '100%',
      }}
    >
      <Box
        sx={{
          background: 'linear-gradient(90deg, #2D63FF 0%, #6444FE 100%)',
          py: 2,
          textAlign: 'center',
        }}
      >
        <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, fontSize: '1.1rem' }}>
          {title}
        </Typography>
      </Box>

      <TableContainer sx={{ minHeight: 300, height: 400, overflowY: 'auto', position: 'relative' }}>
        <Table size="small" aria-label="squad performance table">
          <TableHead sx={{ bgcolor: '#F4F7FC', position: 'sticky', top: 0 }}>
            <TableRow>
              {header.map((v, i) => (
                <TableCell key={i} sx={{ color: '#1E3A8A', fontWeight: 700, borderBottom: '1px solid #E2E8F0' }}>
                  {v}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((value, index) => (
              <TableRow
                key={index}
                sx={{
                  '& td, & th': { borderBottom: 'none', py: 2 },
                  '& td:first-of-type': {
                    textAlign: 'left',
                    fontWeight: 600,
                  },
                  '& td:last-of-type': {
                    color: '#DC2626',
                    fontWeight: 700,
                  },
                }}
              >
                {row.map((v, i) => (
                  <TableCell align="left" sx={{ color: '#475569' }}>
                    {value[v]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          bgcolor: '#F4F7FC',
          borderTop: '1px solid #E2E8F0',
          px: 3,
          py: 2,
        }}
      >
        <Typography sx={{ fontWeight: 800, color: '#1E293B' }}>Total</Typography>
        <Box
          sx={{
            bgcolor: '#3B82F6',
            color: 'white',
            px: 2.5,
            py: 0.75,
            borderRadius: 8,
            fontWeight: 700,
            fontSize: '0.95rem',
          }}
        >
          {total}
        </Box>
      </Box>
    </Card>
  );
}
